var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconSmallHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 76,
    height: 80,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M64.45 25.43V9.15c0-1.374-1.095-2.488-2.445-2.488h-6.848c-1.352 0-2.445 1.114-2.445 2.488v5.94L64.45 25.43z",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M64.45 25.43V9.15 6.663H52.713v8.428L64.45 25.43z",
    stroke: "#09684A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M67.466 75.34H8.768V39.934l29.349-25.9 29.349 25.898z"
  }), /*#__PURE__*/React.createElement("path", {
    stroke: "#09684A",
    strokeWidth: 1.5,
    strokeLinejoin: "round",
    d: "M67.466 75.34H8.768V39.934l29.349-25.9 29.349 25.898z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.794 76.565c0 1.81-14.586 3.276-32.576 3.276-17.992 0-32.576-1.466-32.576-3.276 0-1.81 14.584-3.277 32.576-3.277 17.99 0 32.576 1.467 32.576 3.277",
    fill: "#10C98F",
    opacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.916 41a4.35 4.35 0 01-3.357-1.577 4.513 4.513 0 01-1.03-3.262 4.465 4.465 0 011.54-3.05L35.264 4.742a4.36 4.36 0 012.851-1.069c1.047 0 2.058.382 2.852 1.073L73.172 33.11a4.477 4.477 0 011.536 3.05 4.507 4.507 0 01-1.034 3.263 4.353 4.353 0 01-6.21.507L38.117 14.034l-29.348 25.9A4.354 4.354 0 015.916 41",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.916 41a4.35 4.35 0 01-3.357-1.577 4.513 4.513 0 01-1.03-3.262 4.465 4.465 0 011.54-3.05L35.264 4.742c.529-.458 1.48-1.255 2.853-2.391 1.371 1.136 2.321 1.935 2.85 2.395L73.172 33.11a4.477 4.477 0 011.536 3.05 4.507 4.507 0 01-1.034 3.263 4.353 4.353 0 01-6.21.507L38.117 14.034l-29.348 25.9A4.354 4.354 0 015.916 41z",
    stroke: "#09684A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.646 6.663h5.869V3.179c0-1.374-1.094-2.489-2.446-2.489h-.977c-1.35 0-2.446 1.115-2.446 2.489v3.484z",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M55.646 6.663h5.869V3.179 1.63h-5.869v5.032z",
    stroke: "#09684A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.037 75.34h-23.48v-3.897c0-1.146.913-2.076 2.04-2.076h19.4c1.126 0 2.04.93 2.04 2.076v3.897z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M38.037 75.34h-23.48v-3.897-2.076H38.037v5.973z",
    stroke: "#09684A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.102 69.367h-17.61V55.93c0-4.946 3.943-8.957 8.806-8.957 4.86 0 8.804 4.011 8.804 8.957v13.437z",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M35.102 69.367h-17.61V55.93c0-4.946 3.943-8.957 8.806-8.957 4.86 0 8.804 4.011 8.804 8.957v13.437z",
    stroke: "#09684A",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.232 61.903v-2.986",
    stroke: "#10C98F",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.906 32.043c0 3.3-2.627 5.972-5.868 5.972-3.244 0-5.87-2.673-5.87-5.972 0-3.298 2.626-5.97 5.87-5.97 3.241 0 5.868 2.672 5.868 5.97",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.187 27.821a5.8 5.8 0 00-4.15-1.75c-3.242 0-5.87 2.674-5.87 5.971 0 1.65.657 3.144 1.718 4.224l8.302-8.445z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M43.906 32.043c0 3.3-2.627 5.972-5.868 5.972-3.244 0-5.87-2.673-5.87-5.972 0-3.298 2.626-5.97 5.87-5.97 3.241 0 5.868 2.672 5.868 5.97z",
    stroke: "#09684A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.54 66.382h-7.66c-1.125 0-2.039-.93-2.039-2.075V50.542c0-1.148.914-2.076 2.04-2.076h7.66c1.125 0 2.04.928 2.04 2.076v13.765c0 1.146-.915 2.075-2.04 2.075",
    fill: "#C3F1E3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.543 50.767c-.097-1.28-1.121-2.3-2.409-2.3h-6.847c-1.35 0-2.446 1.113-2.446 2.489v11.717l11.702-11.906z",
    fill: "#FFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M56.54 66.382h-9.699v-15.84-2.076H58.581v17.916h-2.04z",
    stroke: "#09684A",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
export default SvgIconSmallHome;